var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleRow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4318_11649)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 2,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(90 26 2)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.71 19.7102L19.71 14.7102C19.801 14.6151 19.8724 14.5029 19.92 14.3802C20.02 14.1367 20.02 13.8636 19.92 13.6202C19.8724 13.4974 19.801 13.3853 19.71 13.2902L14.71 8.29019C14.6167 8.19695 14.5061 8.12299 14.3842 8.07253C14.2624 8.02207 14.1318 7.99609 14 7.99609C13.7337 7.99609 13.4783 8.10188 13.29 8.29019C13.1017 8.47849 12.9959 8.73388 12.9959 9.00019C12.9959 9.26649 13.1017 9.52188 13.29 9.71019L16.59 13.0002L8.99998 13.0002C8.73477 13.0002 8.48041 13.1055 8.29287 13.2931C8.10534 13.4806 7.99998 13.735 7.99998 14.0002C7.99998 14.2654 8.10534 14.5198 8.29287 14.7073C8.48041 14.8948 8.73477 15.0002 8.99998 15.0002L16.59 15.0002L13.29 18.2902C13.1963 18.3831 13.1219 18.4937 13.0711 18.6156C13.0203 18.7375 12.9942 18.8682 12.9942 19.0002C12.9942 19.1322 13.0203 19.2629 13.0711 19.3848C13.1219 19.5066 13.1963 19.6172 13.29 19.7102C13.3829 19.8039 13.4935 19.8783 13.6154 19.9291C13.7373 19.9798 13.868 20.006 14 20.006C14.132 20.006 14.2627 19.9798 14.3846 19.9291C14.5064 19.8783 14.617 19.8039 14.71 19.7102Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4318_11649",
    x: 0.178571,
    y: 0.178571,
    width: 27.6429,
    height: 27.6429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.910714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4318_11649"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.607143
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4318_11649",
    result: "effect2_dropShadow_4318_11649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4318_11649",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRow);
export default __webpack_public_path__ + "static/media/circle-row.e6b2c218f74ebc7d048d27e4dd640eeb.svg";
export { ForwardRef as ReactComponent };